import { B400 } from '../../utils/colors.js';
import { SEARCH_QUERY } from '../groups.js';

var typeAheadQuery = {
    inclusive: true,
    group: SEARCH_QUERY,
    parseDOM: [{ tag: 'span[data-type-ahead-query]' }],
    toDOM: function (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: " + B400,
            },
        ];
    },
    attrs: {
        trigger: { default: '' },
    },
};

export { typeAheadQuery };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/type-ahead-query.js